const API_BASE_URL = "https://jbarchitectseng.com/back-end/api";
// const API_BASE_URL = "http://127.0.0.1:8000/api";

const request = async (method, endpoint, data = null, useToken = false) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (useToken) {
    const token = localStorage.getItem("token");
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }

  const options = {
    method,
    headers,
  };

  if (data) {
    options.body = JSON.stringify(data);
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, options);

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "API Error");
  }

  return await response.json();
};

const ApiService = {
  get: (endpoint, useToken = false) => request("GET", endpoint, null, useToken),
  getById: (endpoint, id, useToken = false) => request("GET", `${endpoint}/${id}`, null, useToken),
  post: (endpoint, data, useToken = false) => request("POST", endpoint, data, useToken),
  put: (endpoint, id, data, useToken = false) => request("PUT", `${endpoint}/${id}`, data, useToken),
  delete: (endpoint, id, useToken = false) => request("DELETE", `${endpoint}/${id}`, null, useToken),
};

export default ApiService;
